import { useLocation } from "react-router-dom";
import { VeraAvatar } from "@/components/tour/VeraAvatar";
import { useTour } from "@/components/tour/TourProvider";

export function PageHelpButton({ sidebar = true }) {
  const { start, active, lang } = useTour();
  const { pathname } = useLocation();
  if (active) return null;
  const label = lang === "es" ? "¿Qué es esta página?" : "Explain this page";
  return (
    <button onClick={() => start("help")} key={pathname} title={label} aria-label={label} data-testid="page-help-button"
      className={`group fixed z-[9990] ${sidebar ? "bottom-[5.5rem] left-4 lg:bottom-5 lg:left-[17rem]" : "bottom-5 left-5"} flex items-center gap-2 rounded-full bg-white border border-slate-200 shadow-lg pl-1 pr-1 py-1 hover:pr-4 transition-[padding] duration-200`}>
      <VeraAvatar size={40} />
      <span className="text-sm font-semibold text-emerald-700 max-w-0 overflow-hidden whitespace-nowrap group-hover:max-w-[180px] transition-[max-width] duration-300">{label}</span>
    </button>
  );
}
